import Background from '../../Common/Background'
import TobaccoUse from '../../Common/TobaccoUse';
import Adventures from '../../Common/Adventures';
import DrivingRecord from '../../Common/DrivingRecord';
import FamilyHistory from '../../Common/FamilyHistory';
import MedicalDetails from '../../Common/MedicalDetails';
import MedicalHistory from '../../Common/MedicalHistory';
import AlcoholDrugAbuse from '../../Common/AlcoholDrugAbuse';
import MyHealthProfile from '../../Common/MyHealthProfile';

export {
  MyHealthProfile,
  Background,
  TobaccoUse,
  Adventures,
  DrivingRecord,
  FamilyHistory,
  MedicalDetails,
  MedicalHistory,
  AlcoholDrugAbuse,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/HealthClassCalculator/index.js